import React from "react";

import { T } from "services/lang/LanguageService";

const EmailTextInfo: React.FC = () => {
  return (
    <div className="flex flex-column">
      <span><strong>{`$\{title}`}</strong> - {T("word.title").toLowerCase()},</span>
      <span><strong>{`$\{submittedAt}`}</strong> - {T("word.submission-time").toLowerCase()},</span>
      <span><strong>{`$\{approvedAt}`}</strong> - {T("word.approval-time").toLowerCase()},</span>
      <span><strong>{`$\{startDate}`}</strong> - {T("word.disconnection-time").toLowerCase()},</span>
      <span><strong>{`$\{endDate}`}</strong> - {T("word.reconnection-time").toLowerCase()},</span>
      <span><strong>{`$\{nowDate}`}</strong> - {T("word.current-time").toLowerCase()},</span>
      <span><strong>{`$\{reason}`}</strong> - {T("word.reason").toLowerCase()},</span>
      <span><strong>{`$\{service}`}</strong> - {T("word.interrupted-service").toLowerCase()},</span>
      <span><strong>{`$\{objects}`}</strong> - {T("mdm.maintenance-object-list").toLowerCase()}:</span>
      <span className="ml-2"><strong>- {`$\{...identifier}`}</strong> - {T("word.identifier").toLowerCase()},</span>
      <span className="ml-2"><strong>- {`$\{...title}`}</strong> - {T("word.title").toLowerCase()},</span>
      <span className="ml-2"><strong>- {`$\{...description}`}</strong> - {T("word.description").toLowerCase()},</span>
      <span className="ml-2"><strong>- {`$\{...address.fullAddress}`}</strong> - {T("word.address").toLowerCase()}.</span>
    </div>
  )
}

export default EmailTextInfo;